import { AddCircle } from "@material-ui/icons";
import { useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useLazyGetInterlinersDetailByIdQuery } from "../../../features/Interliners/InterlinersFieldsSlice";
import Wrapper from "../../Wrapper";
import AddInterliners from "./AddInterliners";
import InterlinersList from "./InterlinersList";

const Interliners = () => {
    const rateCardSection = (useSelector((state) => state.interliner.list)).map((el) => { return ({ id: el.id, ...el.list }) })
    const [getInterlinerRowData, rowData] = useLazyGetInterlinersDetailByIdQuery()
    const interlinerRowData = rowData?.data?.data
    const abc = interlinerRowData?.getInterlinersRateCardDTOs ? interlinerRowData?.getInterlinersRateCardDTOs : []
    const bb = [...rateCardSection, ...abc]
    const [mode, setMode] = useState(null);

    const openAddForm = () => setMode("ADD");
    const openEditForm = () => setMode("EDIT");
    const closeForm = () => setMode(null);


    return (
        <Wrapper>
            <div className="employee">
                <Container fluid>
                    <div className="role-assignment">
                        <div className="role-assignment-name">
                            <h5>List of Agents/Interliners</h5>
                        </div>
                        <div className="add-role-button d-flex">
                            <span ><Button variant="outline-primary"
                                onClick={() => mode === "ADD" || mode === "EDIT" ? closeForm() : openAddForm()}>
                                <AddCircle /> Add Agent/Interliner</Button></span>
                        </div>
                    </div>
                    <Row>
                        <Col sm={12}>
                            {mode != null ?
                                <AddInterliners mode={mode} closeForm={closeForm} rateCardSection={rateCardSection} interlinerRowData={interlinerRowData} getInterlinerRowData={getInterlinerRowData} bb={bb} />
                                : null}
                            <InterlinersList openEditForm={openEditForm} getInterlinerRowData={getInterlinerRowData} interlinerRowData={interlinerRowData} />
                        </Col>
                    </Row>
                </Container>
            </div >
        </Wrapper >
    )
}
export default Interliners;